import { styled } from 'linaria/react';

export const StyledItem = styled.div`
  margin-bottom: 64px;
`;
